import React from 'react'
import { components } from 'cng-web-lib'

import TmpSupplierApiUrls from 'src/apiUrls/TmpSupplierApiUrls'
import FormProperties from './FormProperties'

const {
  form: {
    CngAddForm
  }
} = components

function AddPageDialog({ history, showNotification, onPostSubmitSuccess }) {

  return (

    <CngAddForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      shouldDisableEnterToSubmit
      showNotification={showNotification}
      history={history}
      bodySection={
        < FormProperties.Fields
          disabled={false}
          showNotification={showNotification}
          mode={"add"}
        />

      }
      formikProps={FormProperties.formikProps}
      toClientDataFormat={FormProperties.toClientDataFormat}
      toServerDataFormat={FormProperties.toServerDataFormat}

      create={{
        url: TmpSupplierApiUrls.CREATE,
        onPostSubmitSuccess: onPostSubmitSuccess
      }}
      innerForm={true}
    />
  )

}


export default AddPageDialog
